import { HttpErrorResponse } from '@angular/common/http';
import { ViewChildren } from '@angular/core';
import { ElementRef } from '@angular/core';
import { QueryList } from '@angular/core';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faRefresh, faSignIn } from '@fortawesome/free-solid-svg-icons';
import { SecurityRole } from '../../../shared/literals/shared.literal';
import { INotificationService } from '../../../shared/services/inotification.service';
import { AuthenticationService } from '../../services/authentication.serivce';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy, AfterViewInit {

  sendPasswordResetEmailForm: FormGroup;
  submitted: boolean = false;
  showResetPasswordErrorMessage: string;

  showResetPasswordScreen: boolean = true;

  @ViewChildren("icon") public icons: QueryList<FaIconComponent>;
  @ViewChild("backgroundImage") public bgImage: ElementRef;

  private icon: FaIconComponent;

  get f() { return this.sendPasswordResetEmailForm.controls; }

  constructor(private formBuilder: FormBuilder,
              private auth: AuthenticationService,
              private router: Router,
              private feedbackService: FeedbackMessageService,
              private notificationService: INotificationService,) { }

  ngOnInit() {
    var session = this.auth.getSession();

    //The user is logged in, redirect to homepage
    if (this.auth.isLoggedIn()) {
      var baseUrl = window.location.href.replace(this.router.url, '');
      window.location.replace(baseUrl);
    }


    this.sendPasswordResetEmailForm = this.formBuilder.group({
      email: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
    var img = this.bgImage.nativeElement as HTMLImageElement;
    img.onload = () => { this.backgroundImageOnload(); }
    img.onerror = () => { this.bgError(); }
    img.src = "../../../../assets/images/epc4.jpg";
    if (img.complete) {
      this.showResetPasswordScreen = true;
    }

    this.icons.changes.subscribe((icos: QueryList<FaIconComponent>) => {
      this.icon = icos.first;
    })
  }

  backgroundImageOnload() {
    this.showResetPasswordScreen = true;
  }

  bgError() {
    console.log("Error loading background image");
  }

  ngOnDestroy(): void {
    // Need to clean up our observable subscription to avoid memory leaks 
    this.auth.onDestroy();
  }

  onSubmit() {

    this.submitted = true;

    // stop here if form is invalid
    if (this.sendPasswordResetEmailForm.invalid) {
      return;
    }

    this.auth.sendPasswordResetEmail(this.sendPasswordResetEmailForm.get('email')?.value).subscribe({
      next: (data: any) => {
        if (data.wasSuccessful) {
    /*      this.notificationService.show({ title: "Success!", type: "success", description: data.message });*/
          this.feedbackService.give({ text: "Success! " + data.message, status: "success" });
          setTimeout(() => { this.router.navigate(['/Login']); }, 3000);

        } else {
         // this.notificationService.show({ title: "Error!", type: "error", description: data.message });
          this.feedbackService.give({ text: "Error! " + data.message, status: "error" });
        }
      },
      error: (e: HttpErrorResponse) => {
        var errorMsg: string = e.error;
        if (typeof e.error === "object") {
          errorMsg = e.statusText
        }

        this.showResetPasswordErrorMessage = errorMsg;
        return;
      }
    });
  }

  onReset() {
    this.submitted = false;
    this.sendPasswordResetEmailForm.reset();
  }

}
